import { getTenancyDefaultUrlQuery } from "~/helpers/apollo/apollo-portfolio-filter-helpers";
import type { UrlTabConfig } from "~/helpers/tabs-helpers";
import { PERMISSIONS } from "~/composables/usePermissions";
import type { Property } from "~/helpers/entities/property-helpers";
import type { ComputedRef } from "vue";
import { AssetManagementPropertySubType } from "~/graphql/generated/graphql";

export const useUrlTabsProperty = (property: ComputedRef<Nullable<Property>>) => {
  const t = useTranslator();

  const isProperty = computed(() => property.value?.subType === AssetManagementPropertySubType.Property);
  const hasSalesPermission = useHasPermissions(PERMISSIONS.PORTFOLIO_SALES_READ_ORG);
  const hasValuationsPermission = useHasPermissions(PERMISSIONS.PORTFOLIO_VALUATIONS_READ_ORG);
  const hasActionPlansPermission = useHasPermissions(PERMISSIONS.ACTION_PLANS_READ_ORG);

  const defaultFilterQuery = useDefaultTenancyFilterBookmarkQuery();

  return computed<UrlTabConfig[]>(() => [
    { tabKey: "overview", labelKey: "PORTFOLIO_PROPERTY_OVERVIEW", default: true, disabled: !isProperty.value },
    {
      tabKey: "units",
      labelKey: "PORTFOLIO_PROPERTY_UNITS",
      query: getTenancyDefaultUrlQuery(defaultFilterQuery.result.value?.id),
      disabled: !isProperty.value,
    },
    { tabKey: "opex", labelKey: "PORTFOLIO_PROPERTY_OPEX", disabled: !isProperty.value },
    { tabKey: "capexes", labelKey: "PORTFOLIO_PROPERTY_CAPEX", disabled: !isProperty.value },
    { tabKey: "sales", labelKey: "PORTFOLIO_PROPERTY_SALES", disabled: !hasSalesPermission.result.value || !isProperty.value },
    { tabKey: "balance", labelKey: "PORTFOLIO_PROPERTY_BALANCE", default: !isProperty.value },
    { tabKey: "valuations", labelKey: "PORTFOLIO_PROPERTY_VALUATIONS", disabled: !hasValuationsPermission.result.value || !isProperty.value },
    { tabKey: "actionplans", labelKey: "PORTFOLIO_PROPERTY_ACTION_PLANS", disabled: !hasActionPlansPermission.result.value || !isProperty.value },
  ]);
};
